import { type RefObject, useLayoutEffect, useState } from 'react'
import { ScrollToOptions, Virtualizer } from '@tanstack/react-virtual'

const usePinScrollToBottom = (
  scrollContainer: RefObject<HTMLDivElement>,
  virtualizer: Virtualizer<HTMLDivElement, Element>,
  scrollToIndex: (index: number, options: ScrollToOptions) => void,
  itemsCount: number | undefined
) => {
  const [hasScrolledToBottomOnStart, setHasScrolledToBottomOnStart] =
    useState(false)

  useLayoutEffect(() => {
    if (!scrollContainer.current || !itemsCount) return

    const { clientHeight, scrollTop } = scrollContainer.current

    const lastItem = virtualizer.getVirtualItems().at(-2)
    if (!lastItem) return

    const lastItemIndex = Math.max(itemsCount - 1, 0)

    if (!hasScrolledToBottomOnStart) {
      setHasScrolledToBottomOnStart(true)
      scrollToIndex(lastItemIndex, {
        behavior: 'auto',
      })
    } else if (scrollTop + clientHeight >= lastItem.start) {
      // If the user is close to the bottom, scroll to the last item

      scrollToIndex(lastItemIndex, {
        align: 'end',
        behavior: 'smooth',
      })
    }
  }, [
    hasScrolledToBottomOnStart,
    itemsCount,
    scrollContainer,
    scrollToIndex,
    virtualizer,
  ])
}

export { usePinScrollToBottom }
